module.exports = __webpack_public_path__ + "static/09-2702aaa49dfff9448a9410f6855c24c0.jpg";